import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "~/components/ui";
import type { DipRunAlert } from "~/features/dataImportProjects/hooks/useDipPipelineRun";
import { DipStatusBanner } from "./DipStatusBanner";

type DipRunBannerProps = {
  alert: NonNullable<DipRunAlert>;
  onOpenLogs?: () => void;
  onOpenDryRunResult?: () => void;
  onDismiss: () => void;
};

export function DipRunBanner({ alert, onOpenLogs, onOpenDryRunResult, onDismiss }: DipRunBannerProps) {
  const { t } = useTranslation();
  const isError = alert.type === "error";

  // Static t() calls so i18next-extract (removeUnusedKeys) keeps these keys.
  const titleByKey: Record<string, string> = {
    "run.banner.runComplete": t("feature.dataImportProjects.v2.run.banner.runComplete"),
    "run.banner.dryRunComplete": t("feature.dataImportProjects.v2.run.banner.dryRunComplete"),
    "run.banner.runFailed": t("feature.dataImportProjects.v2.run.banner.runFailed"),
    "run.banner.runTimeout": t("feature.dataImportProjects.v2.run.banner.runTimeout"),
  };
  const title = titleByKey[alert.titleKey] ?? "";

  return (
    <DipStatusBanner
      tone={isError ? "error" : "success"}
      icon={isError ? <X className="size-3.5" /> : <Check className="size-3.5" />}
      title={title}
      actions={
        <>
          {onOpenDryRunResult ? (
            <Button variant="outline" size="sm" onClick={onOpenDryRunResult}>
              {t("ui.dryRunResult")}
            </Button>
          ) : null}
          {isError && onOpenLogs ? (
            <Button variant="outline" size="sm" onClick={onOpenLogs}>
              {t("feature.dataImportProjects.v2.run.banner.openLogs")}
            </Button>
          ) : null}
          <Button variant="ghost" size="icon" onClick={onDismiss} aria-label={t("ui.close")}>
            <X className="size-4" />
          </Button>
        </>
      }
    />
  );
}
